<template>
  <div>
    <div style="position: absolute; width: 81px; z-index: 8; text-align: right">
      <div
        style="
          width: 26px;
          height: 26px;
          float: right;
          border-radius: 0 0 0 12px;
          background-color: rgba(0, 0, 0, 0.5);
        "
        @click="del"
      >
        <i class="el-icon-close" style="font-size: 24px; color: white"></i>
      </div>
    </div>
    <el-upload
      ref="upload"
      class="avatar-uploader"
      :action="url"
      :headers="fileHeaders"
      :show-file-list="false"
      :before-upload="beforeAvatarUpload"
      :on-change="getFile"
      :on-remove="handleUploadRemove"
      accept=".png, .jpg, .jpeg, .PNG, .JPG, .JPEG,.xlsx,.xls,.xlsm"
    >
      <img v-if="imageUrl" :src="imageUrl" class="avatar" />
      <i v-else class="el-icon-plus avatar-uploader-icon" />
    </el-upload>
  </div>
</template>

<script>
import Cookies from "../../utils/cookies";
import { coreFileserverEndpoint } from "@/settings";
export default {
  props: {
    url: {
      type: String,
      // default: coreFileserverEndpoint + "/files",
      default: "====",
    },
    // eslint-disable-next-line vue/require-default-prop
    value: String,
  },
  data() {
    return {
      imageUrl: null,
      fileHeaders: {
        type: "web",
        token: Cookies.getToken(),
      },
    };
  },

  watch: {
    value: function (val) {
      this.imageUrl = val;
    },
  },
  mounted() {
    this.imageUrl = this.value;
  },

  methods: {
    del() {
      this.imageUrl = null;
      this.$emit("input", null);
    },
    beforeAvatarUpload(file) {
      const testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = [
        "GIF",
        "PNG",
        "JPEG",
        "JPG",
        "gif",
        "png",
        "jpg",
        "jpeg",
      ];
      if (extension.indexOf(testmsg) === -1) {
        this.$message.error("上传图片只能是 gif、jpg、png、jpeg 格式!");
        return false;
      }
      const isLt100K = file.size / 1024 < 100;
      if (!isLt100K) {
        this.$message.error("上传图片大小不能超过 100K!");
      }
      // console.log("====", isLt100K);
      return isLt100K;
    },
    getFile(file, fileList) {
      const self = this;
      this.getBase64(file.raw).then((res) => {
        const params = res;
        // this.proofImage = params;
        self.$emit("input", params);
      });
    },
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },

    handleUploadRemove() {
      this.proofImage = "";
      this.ruleForm.message_img = "";
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #20a0ff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
</style>
